import type { VectorElement, VectorShape } from '@/components/canvas/document/publicTypes';
import { type BaseElementConfig, createBase } from '../../registry/factoryShared';

export function createVectorElement(
  config: BaseElementConfig & {
    shape: VectorShape;
    polygonSides?: number;
    starPoints?: number;
    starInnerRatio?: number;
    pathData?: string;
  },
): VectorElement {
  return {
    ...createBase('vector', config),
    data: {
      shape: config.shape,
      polygonSides: config.polygonSides,
      starPoints: config.starPoints,
      starInnerRatio: config.starInnerRatio,
      pathData: config.pathData,
    },
  };
}
